import {
    Button, ButtonProps, ButtonVariant, Component,
    TableRowToolsViewer, TableRowToolsViewerBehavior, PanelProps
} from "@mcleod/components";

const baseToolProps: Partial<ButtonProps> = {
    variant: ButtonVariant.round,
    fillRow: true,
    rowBreak: false,
    focusable: true,
    margin: 0,
    padding: 8,
    borderRadius: 24,
    borderWidth: 0
};

export class AppTableRowToolsViewerBehavior extends TableRowToolsViewerBehavior {
    protected constructor() {
        super();
    }

    override get defaultProps(): Partial<PanelProps> {
        return {
            height: "100%",
            borderRadius: 0,
            padding: 0,
            margin: 0
        }
    }

    override addTools(viewer: TableRowToolsViewer, ellipsisButton: Button, ...tools: Component[]) {
        tools.forEach(tool => {
            if (tool instanceof Button) {
                this.setToolProps(tool);
                viewer.add(tool);
            }
        });
    }

    private setToolProps(tool: Button): void {
        this.setToolAppProps(tool);

        tool.setProps({
            ...baseToolProps,
            caption: tool.displayLabel,
            color: tool.appProps?.color || tool.color,
            backgroundColor: tool.appProps?.backgroundColor || tool.backgroundColor,
            imageProps: { ...tool.imageProps, marginLeft: 0, marginRight: 0, marginBottom: 4 }
        });
        tool._element.style.pointerEvents = 'auto';
        tool._element.style.flexDirection = 'column';
    }

    private setToolAppProps(tool: Component): void {
        tool.appProps ??= {};
        tool.appProps.backgroundColor ??= tool.color
        tool.appProps.color ??= "white";
    }
}

AppTableRowToolsViewerBehavior.register();
